import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { toTitleCase } from 'src/app/utils/utils';
@Component({
  selector: 'app-recent-happenings',
  templateUrl: './recent-happenings.component.html',
  styleUrls: ['./recent-happenings.component.scss']
})
export class RecentHappeningsComponent {
  @Input() data: any;
  @Input() tooltip: any;
  public chartOptions: any;
  public show : boolean = false
  constructor(private translate: TranslateService, private router: Router) { }

  ngOnChanges(): void {
    this.initGraph()
  }

  toggle(){
    this.show = !this.show
  }

  initGraph() {
    const series = Object.values(this.data);

    // Process labels: Remove underscores, translate, and capitalize
    const labels = Object.keys(this.data).map(label => {
        const formattedLabel = label.replace(/_/g, ' '); // Replace underscores with spaces
        const translatedLabel = this.translate.instant(toTitleCase(formattedLabel)); // Translate
        return translatedLabel; // Capitalize
    });

    this.chartOptions = {
        series: series,
        chart: {
            type: 'pie',
            height: 350,
            events: {
                dataPointSelection: (event, chartContext, config) => {
                    this.onLabelClick(config.dataPointIndex);
                }
            }
        },
        labels: labels,
        legend: {
            position: 'bottom'
        },
        title: {
            text: this.translate.instant('Recruitments by Status')
        }
    };
  }

  onLabelClick(index: number): void {
    let status: string;

    switch (index) {
      case 0:
        status = 'under review';
        break;
      case 1:
        status = 'interviewing';
        break;
      case 2:
        status = 'hired';
        break;
      default:
        status = '';
    }

    if (status) {
      this.router.navigate(['/hr/recruitments/list'], { queryParams: { status } });
    }
  }

}
